"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@chakra-ui/react");
var _excluded = ["label", "helperText", "errorMessage", "id", "children", "rightElement", "leftElement", "rightElementStyles", "leftElementStyles"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
// No clue how to move these into the style file so just co-located to keep from slowing down
// Chakra V2 will heavily impact this component
var labelStyle = {
  color: 'gray.600',
  fontWeight: 'normal',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  top: 0,
  left: 0,
  position: 'absolute',
  pointerEvents: 'none',
  padding: 'inherit',
  paddingLeft: 3,
  transformOrigin: 'left top',
  // below is from chakra v2 that I'm pulling in
  transitionProperty: 'scale translate',
  transitionDuration: '200ms'
};
var activeLabelStyles = {
  fontSize: '0.85em',
  transform: 'translateY(-.75rem)',
  _invalid: {
    color: 'error',
    '& .chakra-form__required-indicator': {
      display: 'none'
    }
  }
};
var controlStyles = {
  position: 'relative',
  borderWidth: '0',
  sx: {
    label: labelStyle,
    input: {
      '&::placeholder': {
        // below is from chakra v2 that I'm pulling in
        transitionProperty: 'opacity scale translate',
        transitionDuration: '200ms',
        opacity: 0
      },
      _invalid: {
        '&:focus': {
          borderBottomRadius: 0,
          borderColor: 'primary.default'
        },
        '&:focus + label': {
          color: 'gray.600'
        },
        '& + label': {
          color: 'error',
          transform: 'translateY(-16px)'
        },
        '& + label .chakra-form__required-indicator': {
          //Styling for asterisk always to be red if invalid
          color: 'error'
        },
        '&::placeholder': {
          opacity: 1
        }
      }
    },
    // styles used for when we extend functionality - textarea:not(:placeholder-shown) ~ label
    'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label': _objectSpread({}, activeLabelStyles),
    // should be a cleaner way of doing this
    '.chakra-input__group > .chakra-input__left-element ~ span input': {
      paddingLeft: 10,
      paddingRight: 8 //This should be only when there is a right element - DOM order made this a headache
    },
    '.chakra-input__group > .chakra-input__left-element ~ span select': {
      paddingLeft: 10,
      paddingRight: 8 //This should be only when there is a right element - DOM order made this a headache
    },
    '.chakra-input__group > .chakra-input__left-element ~ span button': {
      paddingLeft: 10,
      paddingRight: 8 //This should be only when there is a right element - DOM order made this a headache
    },
    '.chakra-input__group > .chakra-input__left-element ~ span label': {
      // transform: 'scale(0.85) translateY(-1rem) translateX(.5rem)',
      paddingLeft: '2.5rem'
    },
    // Styling for select
    '.chakra-select__wrapper + label': _objectSpread({}, activeLabelStyles),
    '.FormElement-contains-error': {
      borderColor: 'error'
    },
    '.chakra-button + label': _objectSpread(_objectSpread({}, activeLabelStyles), {}, {
      display: 'flex',
      alignItems: 'center',
      margin: 0,
      marginLeft: '1px'
      // marginTop: 2
    })
  },
  _focusWithin: {
    label: _objectSpread({}, activeLabelStyles),
    input: {
      '&::placeholder': {
        opacity: '1'
      }
    }
  }
};

/**
 * A component used in the homepage/midfunnel refresh of 2024
 * This formControl allows us to standardize the label movement animation as well as the left/right icons
 * Can be used solo but typically will be used by the Refreshed components themselves
 */
var FormControl = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var label = _ref.label,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    children = _ref.children,
    rightElement = _ref.rightElement,
    leftElement = _ref.leftElement,
    rightElementStyles = _ref.rightElementStyles,
    leftElementStyles = _ref.leftElementStyles,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react2.FormControl, (0, _extends2["default"])({}, props, {
    ref: ref
  }, controlStyles), /*#__PURE__*/_react["default"].createElement(_react2.InputGroup, null, leftElement && /*#__PURE__*/_react["default"].createElement(_react2.InputLeftElement, (0, _extends2["default"])({
    pointerEvents: "none",
    top: "52%",
    left: "1.3rem",
    transform: "translate(-50%,-50%)"
  }, leftElementStyles), leftElement), /*#__PURE__*/_react["default"].createElement(_react2.Box, {
    as: "span",
    width: "100%",
    position: "relative"
  }, children, label && /*#__PURE__*/_react["default"].createElement(_react2.FormLabel, {
    htmlFor: id
  }, label)), rightElement && /*#__PURE__*/_react["default"].createElement(_react2.InputRightElement, (0, _extends2["default"])({
    top: "50%",
    right: "-1rem",
    transform: "translate(-50%,-50%)"
  }, rightElementStyles), rightElement)), helperText && /*#__PURE__*/_react["default"].createElement(_react2.FormHelperText, {
    color: "gray.600",
    marginTop: 1,
    fontSize: "xs"
  }, helperText), /*#__PURE__*/_react["default"].createElement(_react2.FormErrorMessage, {
    color: "error",
    marginTop: 1,
    fontSize: "xs"
  }, errorMessage));
});
var _default = exports["default"] = FormControl;